import * as Yup from 'yup'

import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import { useProcurifyIntl } from '@webapp/hooks'
import { type IBudgetCustomFieldConditionValue } from '@webapp/platform/budgets'
import messages from '../messages'

export const useCustomFieldConditionsValidationSchema = () => {
  const intl = useProcurifyIntl()

  return Yup.array(
    Yup.object<IBudgetCustomFieldConditionValue>({
      field: Yup.object<CustomField>().nullable(),
      values: Yup.array(Yup.string()).when('field', {
        is: (field) => !!field,
        then: Yup.array(Yup.string()).min(
          1,
          intl.formatMessage(messages.valuesRequiredError)
        ),
      }),
    })
  )
}
